import { render, staticRenderFns } from "./dyCardList.vue?vue&type=template&id=00a3f972&scoped=true"
import script from "./dyCardList.vue?vue&type=script&lang=js"
export * from "./dyCardList.vue?vue&type=script&lang=js"
import style0 from "./dyCardList.vue?vue&type=style&index=0&id=00a3f972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3f972",
  null
  
)

export default component.exports